"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToBottom = exports.getScrollElement = void 0;
var _MessageContainer = require("../components/MessageContainer");
var getScrollElement = function getScrollElement(rootId) {
  var selector = rootId ? "#".concat(rootId, " #").concat(_MessageContainer.PREFIX) : "#".concat(_MessageContainer.PREFIX);
  var ele = document.querySelector(selector);
  return ele;
}; // 滚动到底部

exports.getScrollElement = getScrollElement;
var scrollToBottom = function scrollToBottom(rootId) {
  var scrollEle = getScrollElement(rootId);
  if (!scrollEle) {
    return;
  }
  var scrollHeight = scrollEle.scrollHeight;
  try {
    scrollEle.scroll({
      top: scrollHeight,
      left: 0,
      behavior: 'smooth'
    });
  } catch (err) {
    scrollEle.scrollTop = scrollHeight;
    scrollEle.scrollLeft = 0;
  }
};
exports.scrollToBottom = scrollToBottom;